import {FileDiffIcon} from '@primer/octicons-react'
import {useSuspenseActivityPageData} from '../../data/use-activity-page-data'
import {SidebarActivityRow} from './SidebarActivityRow'
import {hasChangesRequested, pluralize, sumReviewComments} from './activity-row-helpers'

export function ChangesRequestedRow() {
  const {summary} = useSuspenseActivityPageData()
  if (!hasChangesRequested(summary)) return null

  const count = summary?.changesRequested?.count ?? 0
  const comments = sumReviewComments(summary?.changesRequested?.events ?? [])
  const label =
    comments > 0
      ? `${count} requested changes with ${comments} ${pluralize(comments, 'comment', 'comments')}`
      : `${count} requested changes`

  return <SidebarActivityRow icon={FileDiffIcon} label={label} group="changesRequested" expectedCount={count} />
}
